export const EMPLOYEE = 'Employee';
export const ASSISTANT = 'Assistant';
export const HR_ADMINISTRATOR = 'HR-administrator';
export const ADMINISTRATION_DEPARTMENT = 'Administration Department';
